import { useCallback } from 'react'
import { useFilteredTasks } from './useFilteredTasks'
import type { TaskDocument } from '@/lib/db/rxdb/schemas/task'

/**
 * Hook that returns someday tasks (tasks marked as someday with open status)
 */
export function useSomedayTasks() {
  const predicate = useCallback(
    (task: TaskDocument, openStatusIds: ReadonlyArray<string>) =>
      openStatusIds.includes(task.statusId) && !task.isArchived,
    [],
  )

  return useFilteredTasks({
    queryFilter: { isSomeday: true },
    predicate,
    assignedToMeOnly: true,
  })
}
